import { useIsAuthenticated } from '@heidi/auth/state';
import type { components } from '@heidi/schema/ml-scribe';
import { useQuery } from '@tanstack/react-query';

import { GET_USER_EHR } from '../../contracts/queryKeys';
import { getUserEHR } from '../api/ehr-profile';

type EHRProfileResponse = components['schemas']['EHRProfileResponse'];

export function useQueryUserEHR<T = EHRProfileResponse>({
  enabled,
  select,
  onUserEhrFetchError,
}: {
  enabled: boolean;
  select?: (data: EHRProfileResponse) => T;
  onUserEhrFetchError: (error: unknown) => void;
}) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQuery({
    queryKey: [GET_USER_EHR],
    enabled: enabled && isAuthenticated,
    select,
    queryFn: async () => {
      try {
        const { data } = await getUserEHR();
        return data;
      } catch (error) {
        onUserEhrFetchError(error);
        throw new Error();
      }
    },
  });
}
